import { render, staticRenderFns } from "./LeadNote.vue?vue&type=template&id=02a90f28&"
import script from "./LeadNote.vue?vue&type=script&lang=js&"
export * from "./LeadNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports